import { createStandardPublicClientApplication } from '@azure/msal-browser';
import { UATConstants } from './Common/Models/UATConstants';

export const requiresInteraction = (errorMessage) => {
  if (!errorMessage || !errorMessage.length) {
    return false;
  }

  return (
    errorMessage.indexOf('consent_required') > -1 ||
    errorMessage.indexOf('interaction_required') > -1 ||
    errorMessage.indexOf('login_required') > -1
  );
};

export const fetchMsGraph = async (url, accessToken, methodType, data) => {
  const requestHeaders = { Authorization: `Bearer ${accessToken}` };
  const requestOptions = {
    method: methodType ? methodType : 'GET',
    headers: requestHeaders,
    body: data ? JSON.stringify(data) : undefined,
  };
  const response = await fetch(url, requestOptions);
  return response.json();
};

export const fetchMsGraphProfilePic = async (url, accessToken, methodType, data) => {
  const requestHeaders = {
    Authorization: `Bearer ${accessToken}`,
    'Content-Type': 'blob',
  };
  const requestOptions = {
    method: methodType ? methodType : 'GET',
    headers: requestHeaders,
    body: data ? JSON.stringify(data) : undefined,
  };

  const response = await fetch(url, requestOptions);

  return response.blob();
};

export const isIE = () => {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ') > -1;
  const msie11 = ua.indexOf('Trident/') > -1;
  const isEdge = ua.indexOf('Edge/') > -1;

  return msie || msie11 || isEdge;
};

export const GRAPH_SCOPES = {
  OPENID: 'openid',
  PROFILE: 'profile',
  USER_READ: 'User.Read',
  USER_READ_ALL: 'User.Read.All',
  USER_READBASIC_ALL: 'User.ReadBasic.All',
  MAIL_READ: 'Mail.Read',
  ACCESS_AS_USER: 'api://64ad0cee-a22c-4aa2-96c9-9a9545b83910/access_as_user',
  CORE_API_ACCESS_AS_USER: 'api://97f5c6b5-18ce-4121-bddd-d52be5c47557/access_as_user',
  DEVOPS_API_ACCESS_AS_USER: '499b84ac-1321-427f-aa17-267ca6975798/user_impersonation',
  GROUPMEMBER_READ_ALL: 'GroupMember.Read.All',
};

export const GRAPH_ENDPOINTS = {
  ME: 'https://graph.microsoft.com/v1.0/me',
  MAIL: 'https://graph.microsoft.com/v1.0/me/messages',
  PHOTO: 'https://graph.microsoft.com/v1.0/me/photos/48x48/$value',
  USER: 'https://graph.microsoft.com/v1.0/users/',
};

export const GRAPH_REQUESTS = {
  LOGIN: {
    scopes: [
      GRAPH_SCOPES.OPENID,
      GRAPH_SCOPES.PROFILE,
      GRAPH_SCOPES.USER_READ,
      GRAPH_SCOPES.USER_READBASIC_ALL,
      GRAPH_SCOPES.GROUPMEMBER_READ_ALL,
    ],
  },
  EMAIL: {
    scopes: [GRAPH_SCOPES.MAIL_READ],
  },
  PHOTO: {
    scopes: [GRAPH_SCOPES.OPENID],
  },
  API: {
    scopes: [GRAPH_SCOPES.ACCESS_AS_USER],
  },
  CoreAPI: {
    scopes: [GRAPH_SCOPES.CORE_API_ACCESS_AS_USER],
  },
  DevopsAPI: {
    scopes: [GRAPH_SCOPES.DEVOPS_API_ACCESS_AS_USER],
  },
};

const tenant = '72f988bf-86f1-41af-91ab-2d7cd011db47';

export const msalApp = await createStandardPublicClientApplication({
  auth: {
    clientId: UATConstants.ClientId,
    authority: 'https://login.microsoftonline.com/' + tenant,
    postLogoutRedirectUri: UATConstants.WebUiUrl,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
});
